import React from 'react';
import GoogleMeetIcon from "../../../assets/icons/google-meet.svg";
import { Col } from "reactstrap";
import { Link } from "react-router-dom";
import { GOOGLE_MEET_APP_ID } from '../../../data/integration-app';
import Linked from "./Linked";


const GoogleMeet = ({connectedVenues}) => {
    
    return (
        <Col md="6" xxl="3" xl="4">
            <Link
            to="/integrations/meet"
            className="int-col"
            >
            {connectedVenues.some(data => parseInt(data.app_id) === GOOGLE_MEET_APP_ID) && <Linked />}    
            <div className="img">
                <img src={GoogleMeetIcon} alt="Google Calendar" />
            </div>
            <div className="text">
                <h3>Google Meet</h3>
                <p>
                Connect and collaborate with Google Meet — secure video meetings made easy.
                </p>
            </div>
            </Link>
        </Col>
    );
}

export default GoogleMeet;